var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_13594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4C15.287 4 17.763 5.257 19.526 6.813C20.411 7.594 21.14 8.471 21.654 9.344C22.159 10.201 22.5 11.13 22.5 12C22.5 12.87 22.16 13.799 21.654 14.656C21.14 15.529 20.411 16.406 19.526 17.187C17.763 18.743 15.286 20 12.5 20C9.713 20 7.237 18.743 5.474 17.187C4.589 16.406 3.86 15.529 3.346 14.656C2.84 13.799 2.5 12.87 2.5 12C2.5 11.13 2.84 10.201 3.346 9.344C3.86 8.471 4.589 7.594 5.474 6.813C7.237 5.257 9.714 4 12.5 4ZM12.5 6C10.316 6 8.292 6.993 6.798 8.312C6.054 8.968 5.466 9.685 5.069 10.359C4.663 11.049 4.5 11.62 4.5 12C4.5 12.38 4.663 12.951 5.069 13.641C5.466 14.315 6.054 15.031 6.798 15.688C8.292 17.007 10.316 18 12.5 18C14.684 18 16.708 17.007 18.202 15.688C18.946 15.031 19.534 14.315 19.931 13.641C20.337 12.951 20.5 12.38 20.5 12C20.5 11.62 20.337 11.049 19.931 10.359C19.534 9.685 18.946 8.969 18.202 8.312C16.708 6.993 14.684 6 12.5 6ZM12.5 9C12.588 9 12.675 9.004 12.761 9.011C12.5439 9.39185 12.4579 9.8335 12.5163 10.268C12.5747 10.7025 12.7743 11.1057 13.0843 11.4157C13.3943 11.7257 13.7975 11.9253 14.232 11.9837C14.6665 12.0421 15.1081 11.9561 15.489 11.739C15.5416 12.3412 15.411 12.9452 15.1145 13.4719C14.8179 13.9986 14.3692 14.4234 13.827 14.6907C13.2849 14.958 12.6746 15.0553 12.0762 14.9699C11.4778 14.8844 10.9192 14.6202 10.4736 14.2118C10.0279 13.8034 9.71603 13.27 9.57876 12.6813C9.44149 12.0926 9.48524 11.4762 9.70429 10.9128C9.92334 10.3495 10.3075 9.8654 10.8063 9.52407C11.3052 9.18274 11.8955 9.00008 12.5 9Z",
    fill: "#533685"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_13594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIco);
export default __webpack_public_path__ + "static/media/eye-ico.0bde4a985011892f236f630e9df70eea.svg";
export { ForwardRef as ReactComponent };